/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentResult { 
    /**
     * Payment transaction identifier in the payment gateway. Maximum lenght 255.
     */
    transactionId?: string;
    /**
     * Payment date. Format yyyy-MM-dd HH:mm:ss
     */
    paymentDate?: string;
    /**
     * Payment amount.
     */
    amount?: number;
    /**
     * Payment currency code. Maximum lenght 3. Examples: EUR, GBP...
     */
    currency?: string;
    /**
     * Payment status. Maximum lenght 50. Examples: Completed, Pending...
     */
    status?: string;
    /**
     * Payment gateway. Maximum lenght 50. Examples: Stripe, Paypal...
     */
    gateway?: string;
    /**
     * Payment receipt. Encoded in Base64 format. Maximum length 11 MB
     */
    paymentReceipt?: PaymentResult.PaymentReceiptEnum;
}
export namespace PaymentResult {
    export type PaymentReceiptEnum = '[B@21ac5eb4';
    export const PaymentReceiptEnum = {
        B21ac5eb4: '[B@21ac5eb4' as PaymentReceiptEnum
    };
}


